import { Modal, SwitchInput, useFormContext } from "@4uhub/lib4uhub";
import { memo, useCallback, useState } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TTicketServiceAreaForm } from "../TicketServiceAreaSchema";
import { ModalContent } from "./ModalContent/ModalContent";
import { IEnableFieldProps } from "./models";

const translationPath = "chatBot.page.service.ticketServiceArea.";

export const EnableField = memo(({ currentValue }: IEnableFieldProps) => {
  const { t } = useTranslation();

  const { setValue, control } = useFormContext<TTicketServiceAreaForm>();

  const currentTicketServiceArea = useWatch({
    name: "ticketServiceArea",
    control,
  });

  const [open, setOpen] = useState(false);

  const [isEnabled, setIsEnabled] = useState(true);

  const openModalHandler = useCallback(() => setOpen(true), []);

  const confirmModalHandler = useCallback(() => {
    setOpen(false);
  }, []);

  const closeModalHandler = useCallback(() => {
    setValue("enable", currentValue);
    setOpen(false);
  }, [currentValue]);

  const changeValueHandler = useCallback(
    (value: boolean) => {
      if (currentTicketServiceArea) return;

      if (currentValue !== value) {
        openModalHandler();
      }
      setIsEnabled(value);
    },
    [currentValue, currentTicketServiceArea, openModalHandler]
  );

  return (
    <>
      <Modal
        open={open}
        onClose={closeModalHandler}
        title={
          currentValue && !isEnabled
            ? `${t(translationPath + "enableModal.disable")}`
            : `${t(translationPath + "enableModal.enable")}`
        }
      >
        <ModalContent
          currentValue={currentValue}
          isEnabled={isEnabled}
          onClose={closeModalHandler}
          onConfirm={confirmModalHandler}
        />
      </Modal>
      <SwitchInput
        name="enable"
        label={t(translationPath + "enable")}
        onValueChange={changeValueHandler}
      />
    </>
  );
});
